// extracted by mini-css-extract-plugin
export default {"container":"reservationInfo_container__mG-St","header":"reservationInfo_header__tJT9m"};